import React from "react";
import {useTranslation} from "react-i18next";
import {NavLink, useRouteMatch} from "react-router-dom";
import {useSelector} from "react-redux";

//actions:
import {
    selectAllActiveCredentialsLength,
    selectAllInactiveCredentialsLength,
    selectAllPendingCredentialsLength,
} from "../../../redux_slices/settingsCredentialsSlice";

const MenuComponent = () => {
    const {t} = useTranslation();
    let {path} = useRouteMatch();

    const activeCredentialsLength = useSelector(selectAllActiveCredentialsLength);
    const inActiveCredentialsLength = useSelector(selectAllInactiveCredentialsLength);
    const pendingCredentialsLength = useSelector(selectAllPendingCredentialsLength);

    return (
        <div className="userspage_tabs_container">
            <div className="userspage_tab">
                <NavLink exact to={`${path}`} activeClassName="active">
                    <div className={"mr-3 ml-3"}>
                        <span className="text">{t("ADMINPANEL.USERS.NAVBAR.TAB1")}</span>
                        {activeCredentialsLength ? (
                            <span className={"ml-2 badge badge-primary"}>{activeCredentialsLength}</span>
                        ) : null}
                    </div>
                    <span className="underLine" />
                </NavLink>
            </div>
            <div className="userspage_tab">
                <NavLink to={`${path}/pending`} activeClassName="active">
                    <div className={"mr-3 ml-3"}>
                        <span className="text">{t("ADMINPANEL.USERS.NAVBAR.TAB2")}</span>
                        {pendingCredentialsLength ? (
                            <span className={"ml-2 badge badge-primary"}>{pendingCredentialsLength}</span>
                        ) : null}
                    </div>
                    <span className="underLine" />
                </NavLink>
            </div>

            <div className="userspage_tab">
                <NavLink to={`${path}/deactivated`} activeClassName="active">
                    <div className={"mr-3 ml-3"}>
                        <span className="text">{t("ADMINPANEL.USERS.NAVBAR.TAB3")}</span>
                        {inActiveCredentialsLength ? (
                            <span className={"ml-2 badge badge-primary"}>{inActiveCredentialsLength}</span>
                        ) : null}
                    </div>
                    <span className="underLine" />
                </NavLink>
            </div>
        </div>
    );
};

export default MenuComponent;
